/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BookingStrictHttpResponse } from '../../booking-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthCareServiceModel } from '../../models/health-care-service-model';
import { HealthCareServiceRequestModel } from '../../models/health-care-service-request-model';

export interface HealthFindrHealthCareServicesPost$Params {
      body?: HealthCareServiceRequestModel
}

export function healthFindrHealthCareServicesPost(http: HttpClient, rootUrl: string, params?: HealthFindrHealthCareServicesPost$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<Array<HealthCareServiceModel>>> {
  const rb = new RequestBuilder(rootUrl, healthFindrHealthCareServicesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BookingStrictHttpResponse<Array<HealthCareServiceModel>>;
    })
  );
}

healthFindrHealthCareServicesPost.PATH = '/HealthFindr/HealthCareServices';
